import { Switch } from '@thanx/uikit/switch'
import { buildTranslate } from 'locales'
import { Button } from 'react-bootstrap'

import ModifierItem from 'components/ModifierList/Item'
import { useShowMore } from 'hooks/useShowMore'

import type { Fields as Modifier } from 'models/Modifier'

const t = buildTranslate('redeem_manager.detail.cards.online_redemption')

interface ModifierItemsProps {
  orderedSelectedModifiers: Modifier[]
  deleteItem: (uid: string) => void
  productIds?: string[]
}

const ModifierItems = ({
  deleteItem,
  orderedSelectedModifiers = [],
  productIds = [],
}: ModifierItemsProps) => {
  const handleDelete = id => () => deleteItem(id)
  const reversedSelectedModifiers = [...orderedSelectedModifiers].reverse()
  const { visibleItems, hiddenCount, hasHidableItems, toggleShowAll, showAll } =
    useShowMore(reversedSelectedModifiers)

  return (
    <div>
      {visibleItems.map(modifier => (
        <ModifierItem
          key={modifier.option.chain_uid}
          modifier={modifier}
          canDelete
          onDelete={handleDelete(modifier.option.chain_uid)}
          productIds={productIds}
        />
      ))}
      <Switch condition={hasHidableItems}>
        <Button
          bsStyle="link"
          type="button"
          onClick={toggleShowAll}
          className="p-0 m-0"
        >
          {showAll ? t('show_less') : t('show_more', { count: hiddenCount })}
        </Button>
      </Switch>
    </div>
  )
}

export default ModifierItems
